
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a/auth",
      function () {
        return require("private-next-pages/a/auth/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/a/auth"])
      });
    }
  